var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M2.995.333h8.525c.322 0 .769.186.992.41l6.412 6.414c.226.226.41.676.41.992v13.185c0 1.288-1.044 2.333-2.336 2.333H3.002c-1.29 0-2.335-1.048-2.335-2.334V2.667C.667 1.378 1.712.333 2.995.333z",
    transform: "translate(-912 -238) translate(776 164) translate(136 74)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.833 2.667H2.995L3 21.333h13.998l.002-10.5h-7c-.644 0-1.167-.522-1.167-1.166v-7z",
    transform: "translate(-912 -238) translate(776 164) translate(136 74)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.167 8.5L17 8.5 11.167 2.667z",
    transform: "translate(-912 -238) translate(776 164) translate(136 74)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M4.167 17.833c0-.644.524-1.166 1.161-1.166h9.344c.641 0 1.161.518 1.161 1.166 0 .645-.524 1.167-1.161 1.167H5.328c-.641 0-1.161-.518-1.161-1.167zM4.167 14.333c0-.644.526-1.166 1.171-1.166h4.657c.647 0 1.172.518 1.172 1.166 0 .645-.526 1.167-1.172 1.167H5.338c-.647 0-1.171-.518-1.171-1.167z",
    transform: "translate(-912 -238) translate(776 164) translate(136 74)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsNext);
export default __webpack_public_path__ + "static/media/fs_next.c64436c09068254bc261ca9f178dd50b.svg";
export { ForwardRef as ReactComponent };